module.exports = __webpack_public_path__ + "img/denim.be5030ca.webp";